module.exports = __webpack_public_path__ + "img/NFC-3.e9946a6c.png";